<template>
    <div style="padding-top: 1rem">
        <!--<navTitle title="确认充值申请" :ask="true"></navTitle>-->
        <navTitle :title="$router.app._route.query.ti?$router.app._route.query.ti:$t('message.recharge.confirm_title')"
                  :ask="true" askName="USDT" path="/user/Recharge_cash"></navTitle>

        <div class="list" v-if="list">
            <div class="title">{{$t('message.recharge.confirm_verify_information')}}</div>
            <div class="li">
                <div class="info red">
                    <!--                    Please don't deposit any other digital assets except BinancePay to the above address, And make sure you send exactly the right amount!-->
                    {{$t('message.recharge.confirm_tip')}}
                    <!--                    Send money to any of the following accounts using the bound BinancePay.-->
                </div>
                <div v-if="parseInt(price)===1||parseInt(price)===10||parseInt(price)===100">
                    <div class="row" style="margin-bottom:30px" v-for="(item,index) in list['USDT_TRC20']">
                        {{$t('message.recharge.confirm_our_pay_id')}}{{index+1}}: {{item}}
                        <span class="copy copy-data" :data-clipboard-text="item" @click="copy">{{$t('message.recharge.confirm_copy')}}</span>
                    </div>
                </div>
                <div v-else-if="parseInt(price)===2||parseInt(price)===20||parseInt(price)===200">
                    <div class="row" style="margin-bottom:30px" v-for="(item,index) in list['USDT_ERC20']">
                        {{$t('message.recharge.confirm_our_pay_id')}}{{index+1}}: {{item}}
                        <span class="copy copy-data" :data-clipboard-text="item" @click="copy">{{$t('message.recharge.confirm_copy')}}</span>
                    </div>
                </div>
                <div v-else>
                    <div class="row" style="margin-bottom:30px" v-for="(item,index) in list['Binance']">
                        {{$t('message.recharge.confirm_our_pay_id')}}{{index+1}}: {{item}}
                        <span class="copy copy-data" :data-clipboard-text="item" @click="copy">{{$t('message.recharge.confirm_copy')}}</span>
                    </div>
                </div>
                <div class="row">{{$t('message.recharge.confirm_top_up_amount')}}: {{price}}
                    <span class="cash" style="font-size: .2rem"> USDT</span>
                    <!--                    <span class="copy copy-data" :data-clipboard-text="$route.query.m" @click="copy">Copy</span>-->
                </div>
                <!--                <div class="row">My account:{{u1}}</div>-->
                <button class="pay-btn bg-color-blue" @click="recharge">{{$t('message.recharge.confirm_top_up_amount')}}</button>
            </div>
        </div>
    </div>
</template>
<script>
    import {mapGetters} from "vuex";
    import {recharge_apply_usdt, recharge_cash_account} from "../../api/user";

    import navTitle from "@components/navTitle";
    import ClipboardJS from "clipboard";

    export default {
        name: "Recharge",
        components: {navTitle},
        props: {},
        data: function () {
            return {
                price: '',
                list: '',
            };
        },
        computed: mapGetters(["userInfo"]),
        mounted: function () {
            this.init()
        },
        methods: {
            copy() {
                let copybtn = document.getElementsByClassName("copy-data");
                const clipboard = new ClipboardJS(copybtn);
                clipboard.on("success", () => {
                    this.$dialog.success(this.$t('message.recharge.confirm_msg_copy'));
                });
            },
            init() {
                this.real_name = this.userInfo.real_name;
                this.mobile = this.userInfo.phone;
                this.email = this.userInfo.email;
                this.price = this.$route.query.m
                // this.u1 = this.$route.query.u1
                // this.type = this.$route.query.type
                // this.cid = this.$route.query.cid
                this.getList()
            },
            getList() {
                this.$dialog.loading.open('Loading...')
                recharge_cash_account().then(res => {
                    this.$dialog.loading.close()
                    let string = res.data.USDT_TRC20
                    res.data.USDT_TRC20 = string.split(',')

                    string = res.data.USDT_ERC20
                    res.data.USDT_ERC20 = string.split(',')

                    string = res.data.Binance
                    res.data.Binance = string.split(',')

                    this.list = res.data
                    // console.log(this.list['USDT_ERC20'])
                })
                    .catch(res => {
                        this.$dialog.loading.close()
                    })
            },

            recharge: function () {
                let that = this, price = Number(this.price);
                if (price === 0) {
                    return that.$dialog.toast({mes: this.$t('message.recharge.confirm_msg_enter_amount')});
                } else if (price < 1) {
                    return that.$dialog.toast({mes: this.$t('message.recharge.confirm_transfer_amount')});
                }
                this.$dialog.confirm({
                    // mes: "Please confirm that the bound binance pay has been used to pay us.<b style='color: red'> Please wait for 5-10 minutes to arrive. </b>If you have any questions, please contact customer service in time.",
                    mes: this.$t('message.recharge.confirm_alert_mes'),
                    title: this.$t('message.recharge.confirm_alert_title'),
                    opts: [
                        {
                            txt: this.$t('message.recharge.confirm_alert_cancel'),
                            color: false,
                            callback: () => {
                                return that.$dialog.toast({mes: this.$t('message.recharge.confirm_alert_msg_cancelled')});
                            }
                        },
                        {
                            txt: this.$t('message.recharge.confirm_alert_confirm'),
                            color: "#00C3F9",
                            callback: () => {
                                this.$dialog.loading.open('loading...')
                                recharge_apply_usdt({price: price}).then(res => {
                                    this.$dialog.loading.close();
                                    that.$dialog.toast({mes: res.msg})
                                    setTimeout(function () {
                                        that.$router.replace({path: '/user/Recharge_cash', query: {r: 1}})
                                    }, 2000)
                                }).catch(res => {
                                    this.$dialog.loading.close();
                                    that.$dialog.toast({mes: res.msg});
                                });
                            }
                        }
                    ]
                });
            }
        }
    };
</script>
<style scoped>
    #iframe {
        display: none;
    }

    .recharge {
        width: 7.03rem;
        padding: 0.5rem 0.63rem 0.45rem;
        background-color: #fff;
        margin: 0.2rem auto 0 auto;
        border-radius: 0.1rem;
    }

    .recharge .nav {
        height: 0.75rem;
        line-height: 0.75rem;
        /*padding: 0 1rem;*/
        margin-bottom: 1rem;
    }

    .recharge .nav .item {
        font-size: 0.3rem;
        color: #333;
    }

    .recharge .nav .item.on {
        font-weight: bold;
        border-bottom: 0.04rem solid #00C3F9;
    }

    .recharge .info-wrapper {
        text-align: center;
    }

    .recharge .info-wrapper .money {
        margin-top: 0.6rem;
        padding-bottom: 0.2rem;
        border-bottom: 1px dashed #ddd;
    }

    .recharge .info-wrapper .money span {
        font-size: 0.56rem;
        color: #333;
        font-weight: bold;
    }

    .recharge .info-wrapper .money input {
        display: inline-block;
        width: 3rem;
        font-size: 0.84rem;
        text-align: center;
        color: #282828;
        font-weight: bold;
        padding-right: 0.7rem;
    }

    .recharge .info-wrapper .money input::placeholder {
        color: #ddd;
    }

    .recharge .info-wrapper .money input::-webkit-input-placeholder {
        color: #ddd;
    }

    .recharge .info-wrapper .money input:-moz-placeholder {
        color: #ddd;
    }

    .recharge .info-wrapper .money input::-moz-placeholder {
        color: #ddd;
    }

    .recharge .info-wrapper .money input:-ms-input-placeholder {
        color: #ddd;
    }

    .recharge .info-wrapper .tips {
        font-size: 0.26rem;
        color: #888;
        margin: 0.25rem auto 0 auto;
        line-height: 1.5;
        padding: 0 0.3rem;
    }

    .recharge .info-wrapper .tips span {
        color: #ef4a49;
    }

    .recharge .info-wrapper .pay-btn {
        display: block;
        width: 5.5rem;
        height: 0.86rem;
        margin: 0.5rem auto 0 auto;
        line-height: 0.86rem;
        text-align: center;
        color: #fff;
        border-radius: 0.15rem;
        font-size: 0.3rem;
        font-weight: bold;
    }


    .list {
        width: 100%;
        padding: 0 0.3rem;
        box-sizing: border-box;
        margin-top: 0.3rem;
        background: #fff;
    }

    .list .info {
        margin-bottom: 10px;
    }

    .red {
        color: #dd3823;
    }

    .list .title {
        width: 100%;
        height: 1rem;
        line-height: 1rem;
        font-size: 0.3rem;
        border-bottom: 2px solid #00c3f9;
        text-align: center;

    }

    .list .li {
        margin-bottom: 0.15rem;
        border-bottom: 1px dashed #ccc;
        margin-top: 0.15rem;
    }

    .list .li {
        padding: 0.15rem 0;
    }

    .list .li .row {
        width: 100%;
        line-height: 0.5rem;
        height: 0.5rem;

    }

    .pay-btn {
        display: block;
        width: 5.5rem;
        height: 0.86rem;
        margin: 0.5rem auto 0 auto;
        line-height: 0.86rem;
        text-align: center;
        color: #fff;
        border-radius: 0.15rem;
        font-size: 0.3rem;
        font-weight: bold;
    }

    .copy {
        font-size: 0.2rem;
        color: #333;
        border-radius: 0.03rem;
        border: 1px solid #666;
        padding: 0.03rem 0.15rem;
        margin-left: 0.24rem;
    }
</style>
